import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  OnDestroy
} from "@angular/core";
import { LoaderService } from "./../../../../core/services/loader.service";
import { BroadcasterService } from "./../../../../core/services/broadcaster.service";
import { GenericUtils } from "./../../../utilities/";
import { LocalStorageService } from "./../../../services/local-storage.service";
import { FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { pairwise, startWith } from "rxjs/operators";
import { MessageService } from './../../../services/message-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "app-type-text",
  templateUrl: "./type-text.component.html",
  styleUrls: ["./type-text.component.scss"]
})

export class TypeTextComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() model: string = "";
  @Input() placeholder: any;
  @Input() label: string = "";
  @Input() divClass: string = "";
  @Output() textValueEmit = new EventEmitter();
  @Output() ddClickedEvent = new EventEmitter();
  @Input() index = '';
  @Input() defaultValue = "";
  resetValue;
  filterForm: FormGroup;

  constructor(private fb: FormBuilder, private message: MessageService) { }

  textValue(data) {
    this.textValueEmit.emit({
      model: this.model,
      value: data,
      defaultValue: data ? data : this.defaultValue
    });
  }

  ngOnChanges(changes:SimpleChanges){
    if (changes.model && changes.model.isFirstChange) {
      this.filterForm = this.fb.group({[this.model]: ['']});
    }
    if (this.defaultValue && !this.resetValue) {
      this.filterForm.controls[this.model].patchValue(this.defaultValue);
    }
  }

  ngOnInit() {
    // this.filterForm = this.fb.group({
    //   textdata: ""
    // });
    // this.filterForm
    //   .get(this.model)
    //   .valueChanges.pipe(pairwise())
    //   .subscribe(data => {
    //     this.textValue(data);
    //   });

      this.message.getMessage().pipe(takeUntil(this.unsubscribe)).subscribe( message => {
        if (message && message.filterReset) {
          this.resetValue = message.filterReset;
          this.filterForm.reset();
        }
      });
  }

  public click(value: any) {
    this.ddClickedEvent.emit(true);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
